import React from "react";
import {Carousel, Container} from "react-bootstrap";
import {useFetchTeams} from "../../features/team/teamApi";

const TeamListSlider = () => {
    const {data:teams} = useFetchTeams();

    if (!teams) {
        return <></>
    }

    return (
        <Container>
        <Carousel interval={2000}>
            {teams.map((team) => (
                <Carousel.Item key={team.id}>
                    <img
                        src={team.carousel_img}
                        className=" mb-3 rounded-4 img-fluid w-100"
                        alt="Avatar"
                    />
                    <Carousel.Caption>
                        <h3>{team.name}</h3>
                    </Carousel.Caption>
                </Carousel.Item>
            ))}
        </Carousel>
        </Container>
    );
};

export default TeamListSlider;
